import React, { useState } from 'react';
import api from '../../../utils/axios';
import { ChevronDown, ChevronRight, Loader2 } from 'lucide-react';
import { fmtMoney } from './formato';

const Detalle = ({ busquedaId, idBilletera }) => {
  const [data, setData] = useState(null);
  React.useEffect(() => {
    api.get(`/reportes/saldos/busqueda/${busquedaId}/billetera/${idBilletera}`)
      .then(r => setData(r.data))
      .catch(() => setData({ coincidencias: [], error: 'No se pudo cargar el detalle' }));
  }, [busquedaId, idBilletera]);

  if (!data) return <div className="p-3 text-xs text-slate-400"><Loader2 size={14} className="inline animate-spin mr-1" /> Cargando movimientos...</div>;
  const lista = data.coincidencias || [];
  return (
    <div className="bg-slate-50 px-4 py-3" data-testid={`busqueda-detalle-${idBilletera}`}>
      <table className="w-full text-xs">
        <thead>
          <tr className="text-slate-500 text-left">
            <th className="py-1 pr-3 font-medium">ID mov.</th>
            <th className="py-1 pr-3 font-medium">Fecha</th>
            <th className="py-1 pr-3 font-medium">Descripción</th>
            <th className="py-1 pr-3 font-medium text-right">Monto</th>
            <th className="py-1 font-medium text-right">Saldo al momento</th>
          </tr>
        </thead>
        <tbody>
          {lista.map(m => (
            <tr key={m.id_movimiento} className="border-t border-slate-200">
              <td className="py-1 pr-3 font-mono text-slate-500">{m.id_movimiento}</td>
              <td className="py-1 pr-3 whitespace-nowrap">{m.fecha}</td>
              <td className="py-1 pr-3">{m.descripcion}</td>
              <td className={`py-1 pr-3 text-right whitespace-nowrap ${m.monto_num < 0 ? 'text-red-600' : 'text-slate-800'}`}>{m.monto}</td>
              <td className="py-1 text-right whitespace-nowrap text-slate-600">{m.saldo}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {data.cantidad > lista.length && (
        <p className="text-[11px] text-slate-500 mt-2">Se muestran los primeros {lista.length} de {data.cantidad}.</p>
      )}
    </div>
  );
};

export const BusquedaResultadosTabla = ({ busquedaId, resultados }) => {
  const [abierta, setAbierta] = useState(null);
  return (
    <div className="border border-slate-200 rounded-md overflow-hidden max-h-[520px] overflow-y-auto" data-testid="busqueda-resultados-tabla">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 sticky top-0 z-10">
          <tr className="text-left text-[11px] uppercase tracking-wide text-slate-500">
            <th className="w-8" />
            <th className="py-2 pr-3 font-semibold">Billetera</th>
            <th className="py-2 pr-3 font-semibold">CUIT</th>
            <th className="py-2 pr-3 font-semibold">CVU</th>
            <th className="py-2 pr-3 font-semibold text-right">Veces</th>
            <th className="py-2 pr-3 font-semibold text-right">Monto total</th>
            <th className="py-2 pr-3 font-semibold text-right">Movs. revisados</th>
          </tr>
        </thead>
        <tbody>
          {resultados.map(r => {
            const open = abierta === r.id_billetera;
            return (
              <React.Fragment key={r.id_billetera}>
                <tr
                  className="border-t border-slate-100 hover:bg-blue-50/40 cursor-pointer"
                  onClick={() => setAbierta(open ? null : r.id_billetera)}
                  data-testid={`busqueda-fila-${r.id_billetera}`}
                >
                  <td className="pl-2 text-slate-400">{open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}</td>
                  <td className="py-2 pr-3 font-medium text-slate-800">{r.nombre || `Billetera ${r.id_billetera}`}</td>
                  <td className="py-2 pr-3 text-slate-600 whitespace-nowrap">{r.cuit || '—'}</td>
                  <td className="py-2 pr-3 text-slate-600 font-mono text-xs">{r.cvu || '—'}</td>
                  <td className="py-2 pr-3 text-right">
                    <span className="inline-block min-w-[2rem] px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 font-semibold text-xs" data-testid={`busqueda-veces-${r.id_billetera}`}>{r.cantidad}</span>
                  </td>
                  <td className="py-2 pr-3 text-right whitespace-nowrap">{fmtMoney(r.monto_total)}</td>
                  <td className="py-2 pr-3 text-right text-slate-500">{r.revisados}</td>
                </tr>
                {open && (
                  <tr><td colSpan={7} className="p-0"><Detalle busquedaId={busquedaId} idBilletera={r.id_billetera} /></td></tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BusquedaResultadosTabla;
